export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/shareholder-jcb.2f46c4d0-7f2108.png";